<template>
    <div class="user" :class="{show: visible}">
        <div class="user__info" ref="toggle" @click="toggle">
            <Avatar class="user__img" :src="user.avatar" :size="40" backgroundColor="#61c365" :username="user.name" />
            <div>
                <div class="user__name">{{ user.name }}</div>
                <div class="user__email" v-if="user.business_name">{{ user.business_name }}</div>
                <div class="user__email" v-else>{{ user.email }}</div>
            </div>
        </div>

        <div :class="menuClasses" ref="menu" :role="role" @mouseover="onMouseOver" @keydown="onKeydown">
            <DropdownItem :to="{name: 'setup'}">Setup</DropdownItem>
            <DropdownItem to="/logout">Logout</DropdownItem>
        </div>
    </div>
</template>

<script>
import Dropdown from 'bootstrap-vue/src/components/dropdown/dropdown';
import DropdownItem from 'bootstrap-vue/src/components/dropdown/dropdown-item';
import Avatar from 'vue-avatar';

export default {
  name: 'SidebarProfile',
  extends: Dropdown,
  props: ['user'],
  components: {
    Avatar,
    DropdownItem,
  },
  methods: {
  },
};
</script>
